export var UNAVAILABLE = 'UNAVAILABLE';
export var UNAUTHORIZED = 'UNAUTHORIZED';
export var NO_HANDOFF_DATA = 'NO_HANDOFF_DATA';
export var REQUEST_ERROR = 'REQUEST_ERROR';
export var AVAILABLE = 'AVAILABLE';
